import { render, staticRenderFns } from "./CertificateDownload.vue?vue&type=template&id=2093d76a&scoped=true&"
import script from "./CertificateDownload.vue?vue&type=script&lang=js&"
export * from "./CertificateDownload.vue?vue&type=script&lang=js&"
import style0 from "./CertificateDownload.vue?vue&type=style&index=0&id=2093d76a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2093d76a",
  null
  
)

export default component.exports